<form id="parkerSubscriptionListForm" [formGroup]="parkerSubscriptionForm" autocomplete="off">
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label class="control-label required">{{ (useSubscriptionSets ? 'i18n.domain.parker-administration.detail.form.subscription-set' : 'i18n.domain.parker-administration.detail.form.subscription') | translate}}</label>
      <ejs-dropdownlist id="subscription"
                        [dataSource]="subscriptionsDropdownValues"
                        [fields]="dropdownSettings"
                        [showClearButton]="true"
                        [formControl]="parkerSubscriptionForm.controls.subscriptionId"></ejs-dropdownlist>
      <app-error-messages [control]="parkerSubscriptionForm.controls.subscriptionId"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label class="d-block">{{'i18n.domain.parker-administration.detail.form.fromDateImmediate' | translate}}</label>
      <app-yes-no-group-button [formControl]="parkerSubscriptionForm.controls.isValidImmediately"></app-yes-no-group-button>
    </div>
    <div class="form-group col-md-6">
      <label class="control-label"
             [ngClass]="{'required': !parkerSubscriptionForm.controls.isValidImmediately.value}">{{'i18n.domain.parker-administration.detail.form.validFrom' | translate}}</label>
      <ejs-datetimepicker id="validFrom"
                          [formControl]="parkerSubscriptionForm.controls.validFrom"
                          timeFormat="HH:mm"
                          format="dd.MM.yyyy HH:mm"
                          [min]="minDate">
      </ejs-datetimepicker>
      <app-error-messages [control]="parkerSubscriptionForm.controls.validFrom"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">

    <div class="form-group col-md-6">

      <label class="d-block">{{'i18n.domain.parker-administration.detail.form.toDateImmediate' | translate}}</label>
      <app-yes-no-group-button [formControl]="parkerSubscriptionForm.controls.isValidOpenEnd"></app-yes-no-group-button>
    </div>
    <div class="form-group col-md-6">
      <label class="control-label"
             [ngClass]="{'required': !parkerSubscriptionForm.controls.isValidOpenEnd.value}">{{'i18n.domain.parker-administration.detail.form.validTo' | translate}}</label>
      <ejs-datetimepicker id="validTo"
                          formControlName="validTo"
                          timeFormat="HH:mm"
                          format="dd.MM.yyyy HH:mm"
                          [min]="parkerSubscriptionForm.controls.validFrom.value ?? minDate">
      </ejs-datetimepicker>
      <app-error-messages [control]="parkerSubscriptionForm.controls.validTo"></app-error-messages>
    </div>
  </div>
  @if (!isAdd) {
    <div class="form-row row">
      <div class="form-group col-md-12">
        <label class="d-block">{{'i18n.shared.fields.active' | translate}}</label>
        <app-yes-no-group-button id="active3"
                                formControlName="active"></app-yes-no-group-button>
      </div>
    </div>
  }
  @if (!isAdd) {
    <div class="form-row row">
      <div class="form-group col-md-6">
        <label for="modifiedBy" class="d-block">{{'i18n.domain.parker-administration.detail.modified-by' | translate}}</label>
          <input id="modifiedBy"
                        name="modifiedBy"
                        type="text"
                        autocomplete="off"
                        formControlName="modifiedBy"
                        class="form-control">
        </div>
        <div class="form-group col-md-6">
          <label for="modifiedOn" class="d-block">{{'i18n.domain.parker-administration.detail.modified-on' | translate}}</label>

          <input id="modifiedOn"
                        name="modifiedOn"
                        type="text"
                        autocomplete="off"
                        formControlName="modifiedOn"
                        class="form-control">
      </div>
    </div>
  }
</form>
